module.exports = __webpack_public_path__ + "img/10.30604a7c.png";